import React from 'react';
import { PlayCircle } from 'lucide-react';

const Section_1 = ({ setShowVideo }) => {
  return (
    <div className="ace-slide w-full" >
      <div className="ace-slider-center w-full">
        <div className="w-full pt-[80px] pb-[80px] px-6 lg:px-24 py-16 min-h-[50vh] flex flex-col lg:flex-row items-center justify-between">
          {/* Left */}
          <div className="max-w-xl mb-12 lg:mb-0 text-center lg:text-left flex flex-col justify-center items-start gap-6 px-4 sm:px-6">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-relaxed">
              The World's First Fully Automated, Directional Options Trading Bot powered by AI and Machine Learning.
            </h1>
            <div className="flex flex-col sm:flex-row gap-4 items-center sm:items-start">
              <button
                className="flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-white/10 transition"
                onClick={() => setShowVideo(true)}
              >
                <div className="w-10 h-10 rounded-full border border-white flex items-center justify-center">
                  <PlayCircle className="w-5 h-5 text-white" />
                </div>
                <div className="text-left">
                  <div className="text-white font-medium text-base">Watch Video</div>
                  <div className="text-sm text-gray-400">3min</div>
                </div>
              </button>
              <a href="https://calendly.com/marcusm-yzy7/30min" target="_blank">
                <button 
                  style={{color: '#0b0d2a', paddingTop: '15px', paddingBottom: '15px', minWidth: '200px'}}
                  className="rounded-full bg-white z-50 items-center space-x-3 px-4 py-2 rounded-lg text-black text-lg font-bold ">
                  Book a Call
                </button>
              </a>
            </div>
          </div>

          {/* Right */}
          <div className="w-full max-w-3xl relative">
            <img
              src="/photo/1746174420343@2x.jpg"
              alt="AI Powered Visual"
              className="w-full h-auto rounded-3xl shadow-2xl object-cover"
            />
            <div className="absolute top-0 left-0 w-full h-full rounded-3xl bg-gradient-to-l from-[#0b0d2a] via-transparent to-transparent pointer-events-none"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section_1;